/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EasyClaimDataPrivacyLink
 */
export interface EasyClaimDataPrivacyLink {
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimDataPrivacyLink
	 */
	id?: number;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDataPrivacyLink
	 */
	name?: string | null;
}

/**
 * Check if a given object implements the EasyClaimDataPrivacyLink interface.
 */
export function instanceOfEasyClaimDataPrivacyLink(
	value: object
): value is EasyClaimDataPrivacyLink {
	return true;
}

export function EasyClaimDataPrivacyLinkFromJSON(json: any): EasyClaimDataPrivacyLink {
	return EasyClaimDataPrivacyLinkFromJSONTyped(json, false);
}

export function EasyClaimDataPrivacyLinkFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimDataPrivacyLink {
	if (json == null) {
		return json;
	}
	return {
		id: json['id'] == null ? undefined : json['id'],
		name: json['name'] == null ? undefined : json['name'],
	};
}

export function EasyClaimDataPrivacyLinkToJSON(json: any): EasyClaimDataPrivacyLink {
	return EasyClaimDataPrivacyLinkToJSONTyped(json, false);
}

export function EasyClaimDataPrivacyLinkToJSONTyped(
	value?: EasyClaimDataPrivacyLink | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		id: value['id'],
		name: value['name'],
	};
}
